import React from 'react';
import styled from 'styled-components';

const EyeIcon = () => {
return(
    <Container>
        <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.8525 2.40018C16.1053 2.22835 16.429 2.32928 16.5756 2.62578L18.5952 6.71053C18.7418 7.00694 18.6557 7.38659 18.4028 7.5585C18.15 7.73033 17.8263 7.6294 17.6797 7.3329L15.6601 3.24815C15.5135 2.95174 15.5996 2.57209 15.8525 2.40018Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.8879 4.6013C12.1757 4.5419 12.4501 4.76725 12.5008 5.1047L13.127 9.27217C13.1776 9.60971 12.9855 9.93144 12.6977 9.99093C12.4099 10.0503 12.1354 9.82497 12.0847 9.48752L11.4585 5.32005C11.4079 4.98259 11.6001 4.66078 11.8879 4.6013Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.44268 4.5915C7.73046 4.65082 7.92279 4.97247 7.87221 5.31L7.24604 9.48782C7.19546 9.82527 6.92114 10.0508 6.63329 9.99147C6.3455 9.93215 6.15317 9.6105 6.20375 9.27297L6.82992 5.09515C6.8805 4.7577 7.15482 4.53218 7.44268 4.5915Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.47901 2.39953C3.73215 2.57078 3.81899 2.95018 3.67297 3.24701L1.65338 7.35243C1.50735 7.64927 1.18376 7.7511 0.930617 7.57985C0.67747 7.40869 0.590626 7.02921 0.736651 6.73238L2.75625 2.62695C2.90227 2.33012 3.22586 2.22828 3.47901 2.39953Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M0.870756 0.137805C1.0981 -0.0775382 1.43126 -0.0359257 1.61489 0.230627C3.03806 2.2967 5.61767 4.87073 9.66971 4.87073C13.7217 4.87073 16.3013 2.2967 17.7245 0.230627C17.9081 -0.0359257 18.2413 -0.0775382 18.4686 0.137805C18.6959 0.353149 18.7314 0.743795 18.5478 1.01035C17.0077 3.24618 14.1547 6.11167 9.66971 6.11167C5.18467 6.11167 2.33167 3.24618 0.791594 1.01035C0.607964 0.743795 0.643411 0.353149 0.870756 0.137805Z"
                  fill="#333333"/>
        </svg>
    </Container>
)

}
export default EyeIcon;

const Container = styled.div`

`;